import request from './request'

export function listFactory(data) {
  return request.post('/mes/factories/list', data)
}
export function selectFactory() {
  return request.get('/mes/factories/select')
}
export function getFactory(id) {
  return request.get('/mes/factories/' + id)
}
export function saveFactory(data) {
  return request.post('/mes/factories', data)
}
export function updateFactory(data) {
  return request.post('/mes/factories/update', data)
}
export function deleteFactory(ids) {
  return request.post('/mes/factories/delete', ids)
}
export function selectWorkCalendar() {
  return request.get('/mes/work-calendars/select')
}
